import React from "react";
import { Row, Col } from "antd";
import { Link } from "react-router-dom";
import "./Homepage.css";

const Homepage: React.FC = () => {
  return (
    <div className="apply-for-incentive">
      <div className="hero-section-wrapper">
        {/* Main background image that the card overlaps */}
        <img
          src="/images/bike1.webp" /* Explicitly use bike1.png */
          alt="E-bike on city street"
          className="hero-main-background-image"
        />
        {/* Content card that sits on top */}
        <div className="hero-content-card">
          <div className="city-name">City of New Orleans, Louisiana</div>
          <h1 className="program-title">E-Bike Incentive Application</h1>
          <p className="program-description">
            Hello and thank you for your interest in an e-bike subsidy. Before
            you begin your application, please read the program details below to
            determine if applying is right for you.
          </p>
        </div>
      </div>

      <div className="space-115">
        <Row gutter={20}>
          <Col xs={24} lg={12}>
            <div className="program-details-content">
              <div className="program-details">Program Details</div>
              <div className="subsidy-amounts-title">
                Subsidy Amounts and Out-of-Pocket Costs
              </div>
              <div className="subsidy-amounts-description">
                Subsidy amounts are income-based, ranging from $700-$1,400 for
                standard e-bikes and $2,000 for cargo e-bikes. Each subsidy
                recipient also received a $150 credit for safety gear. Subsidies
                are applied at the point of sale. Recipients must pay
                out-of-pocket for the remaining cost of the e-bike (if
                applicable) and sales tax. All sales are final.
                <br />
                <span style={{ fontWeight: 700 }}>
                  The Safety Gear Credit CANNOT be applied to the cost of the
                  e-bike itself.
                </span>{" "}
                This funding is specifically set aside to support the safe
                riding of New Orleans residents and can only be used towards the
                purchase of a helmet, high quality lock and other items.
                <br />
                In order to ensure consistent quality and safety, we've
                partnered with 6 local e-bike retailers. Subsidies can only be
                redeemed at these{" "}
                <span style={{ textDecoration: "underline" }}>locations</span>.
              </div>
              <div className="cost-considerations">Cost considerations</div>
              <div className="cost-considerations-description">
                Qualifying e-bikes start at $999. Please also consider ongoing
                maintenance costs. On average, you can expect to pay at least
                $300 annually for safety tune ups and maintenance.
              </div>
            </div>
          </Col>
          <Col xs={24} lg={12}>
            <img
              src="/images/subsidy-amounts.png"
              className="program-details-image"
              alt="Program details"
            />
          </Col>
        </Row>
      </div>

      <div className="space-139">
        <Row gutter={20}>
          <Col xs={24} lg={12} className="image-column">
            <img
              src="/images/section-3.webp"
              className="cost-explanation-image"
              alt="E-bike cost explanation"
            />
          </Col>
          <Col xs={24} lg={12}>
            <div className="cost-explanation-content">
              <div className="why-do-ebikes-cost-more">
                Why do e-bikes cost more than non-electric bicycles?
              </div>
              <div className="cost-explanation-text">
                E-bikes are incredible machines that provide a new form of
                transportation that can shorten your commute and in many cases
                replace a car. The electrical components on an e-bike, such as
                the motor and battery, are expensive and can make up the
                majority of the total cost of the bike. Many e-bike parts are
                also shipped from overseas, which add a significant expense as
                well.
                <br />
                E-bikes are expensive. New Orleans City Council offers this program
                in order to reduce the cost of e-bike purchases and make them
                more affordable for New Orleans residents.
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <div className="divider"></div>

      <div className="cta-section">
        <div className="cta-content">
          <div className="apply-for-an-ebike-incentive-now">
            Apply for an E-Bike Incentive Now
          </div>
          <div className="application-description">
            The following application will ask you to share your contact
            details, demographic information, and how you plan to use the
            e-bike. You will then need to submit documents to confirm your
            income and residency.
            <br />
            This form will take approximately{" "}
            <span style={{ fontWeight: 700 }}>30 minutes</span> to complete..
            <br />
            Please note:{" "}
            <span style={{ fontWeight: 700 }}>
              Because incentives are limited, not all qualified applicants will
              receive an incentive.
            </span>
          </div>
          <Link to="/application1">
            <div className="button-large">Begin Application Now</div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Homepage;
